import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=66f10db8&scoped=true&"
import script from "./Evaluations.vue?vue&type=script&lang=js&"
export * from "./Evaluations.vue?vue&type=script&lang=js&"
import style0 from "./Evaluations.vue?vue&type=style&index=0&id=66f10db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f10db8",
  null
  
)

export default component.exports